/**
 * @param value
 * @returns {undefined|*}
 */
export function nullToUndefined(value) {
  return value === null ? undefined : value
}
